// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface SignInBlockWrapperStyles {
    wrapper?: InjectableCss;
    content?: InjectableCss;
}

export const signInBlockWrapperStyles: SignInBlockWrapperStyles = {
    wrapper: {
        css: css`
            background-color: ${getColor("common.borderLight")};
            padding: ${pxToRem(3)} ${pxToRem(3)} 0 ${pxToRem(3)};
            border-bottom: 8px solid ${getColor("primary")};
        `,
    },
    content: {
        css: css`
            background-color: ${getColor("common.background")};
            padding: ${pxToRem(20)};

            ${breakpoint("sm")} {
                padding: ${pxToRem(35)};
            }
        `,
    },
};

const styles = signInBlockWrapperStyles;

const SignInBlockWrapper: FC = ({ children }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.content}>{children}</StyledWrapper>
        </StyledWrapper>
    );
};

export default SignInBlockWrapper;
